var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-video"},[_c('div',{staticClass:"video"},[(_vm.youtubeId)?_c('youtube',{ref:"youtube",attrs:{"player-vars":_vm.playerVars,"video-id":_vm.youtubeId}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }